// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"59377658","453":"485121c2","455":"e18fa7d4","977":"81bcfda8"}[chunkId] + ".chunk.js";
};